export class BackupZeroEtlColumnDefinitions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<BackupZeroEtlColumnDefinition>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupZeroEtlColumnDefinitions.attributeTypeMap;
    }
    constructor() {
    }
}
